import React from 'react';
import Barcode from 'react-barcode';

export const  BarCodeGenerate = ({value}) => {
        
    return ( <Barcode width={1.1} height={40} value={value} /> );
};